export default useCancelable = (promise) ->
  isCancelled = false

  wrappedPromise = new Promise((resolve, reject) ->
    try
      val = await promise
      unless isCancelled
        resolve(val)
    catch error
      unless isCancelled
        reject(error)
  )

  cancelledFn = () ->
    isCancelled = true

  Object.assign(wrappedPromise, { cancel: cancelledFn })
